import { baseX } from './base.js';
export const base10 = baseX({
  prefix: '9',
  name: 'base10',
  alphabet: '0123456789'
});